import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../pages/index'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: Index,
    },
    {
        path: '/create/:type/:order_id',
        name: 'craate',
        component: () => import('../pages/create.vue'),
        props: true,
    }
]

const router = new VueRouter({
    mode: 'history',
    base: '/home/',//process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition;
    }
});

router.beforeEach((to, from, next) => {
    if (from.meta.isBack) {
        to.meta.reload = false;
    }
    from.meta.isBack = false;
    next();
});

export default router
